import React, { useState } from "react";
import { Button, Modal } from "../../../BP2Components";
import DedicatedListTable from "./DedicatedListTable";
import PropTypes from "prop-types";
import "./DedicatedListButton.less";
import { Icon_SearchInList } from "../../../BP2Components/Icons/icons";

const DedicatedListButton = ({
   listId,
   form,
   fieldTechname,
   getValueFromAdvancedSearch,
   disabled,
   refreshForm,
   reloadFieldOptions,
}) => {
   const [isOpen, setIsOpen] = useState(false);

   // here we define the modal to be 70vw
   const widthInPixels = (70 * window.innerWidth) / 100;

   return (
      <>
         <Button
            buttonType="third"
            onClick={() => setIsOpen(!isOpen)}
            htmlType="button"
            className="dedicated-list__button"
            disabled={disabled ?? false}
         >
            <Icon_SearchInList fill="var(--first)" />
         </Button>
         <Modal isOpen={isOpen} width={widthInPixels} onCancel={setIsOpen}>
            <DedicatedListTable
               closeModal={setIsOpen}
               listId={listId}
               getValueFromAdvancedSearch={getValueFromAdvancedSearch}
               form={form}
               refreshParentForm={refreshForm}
               fieldTechname={fieldTechname}
               reloadFieldOptions={reloadFieldOptions}
            />
         </Modal>
      </>
   );
};

DedicatedListButton.propTypes = {
   listId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
   form: PropTypes.any.isRequired,
   formTechname: PropTypes.string.isRequired,
   disabled: PropTypes.bool,
};

export default DedicatedListButton;
